import React from 'react';

const Index = () => {
  return (
    <div className='footer'>
        <p className='copy-right'>&copy; MD. Obaidullah Al-Faruk - 2023</p>
    </div>
  )
}

export default Index;